import React from 'react';

const FinancialFormModal = ({ title, onClose, onSave, onDelete, saving, children }) => {
  return (
    <div className="fd-modal-overlay fd-modal-overlay--inner" onClick={onClose}>
      <div className="fd-modal fd-modal--sm fd-modal--form" onClick={(e) => e.stopPropagation()}>
        <div className="fd-modal-header">
          <h3 className="fd-modal-title">{title}</h3>
          <button className="fd-modal-close-x" type="button" onClick={onClose}>✕</button>
        </div>

        <div className="fd-form-body">
          {children}
        </div>

        <div className="fd-modal-footer">
          {onDelete && (
            <button
              className="fd-btn-danger"
              type="button"
              onClick={onDelete}
              disabled={saving}
              style={{ marginRight: 'auto' }}
            >
              Excluir
            </button>
          )}
          <button className="fd-btn-close" type="button" onClick={onClose} disabled={saving}>Cancelar</button>
          <button className="fd-btn-green" type="button" onClick={onSave} disabled={saving}>
            {saving ? 'SALVANDO...' : 'SALVAR'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FinancialFormModal;
